import React from "react";
import useBranding from "../../hooks/useBranding";
import TermsAndConditionSrds from "./TermsAndCondition.srds.jsx";
import TermsAndConditionProschool from "./TermsAndCondition.proschool.jsx";

/**
 * Terms & Condition wrapper.
 * Picks the variant based on current brand.
 * SRDS is the default fallback.
 */
const TermsAndCondition = () => {
  const branding = useBranding();

  if (branding.variant === "proschool") {
    return <TermsAndConditionProschool />;
  }
  return <TermsAndConditionSrds />;
};

export default TermsAndCondition;
